'use strict';

if (typeof Promise === 'undefined') {
  require('promise/lib/rejection-tracking').enable();
  window.Promise = require('promise/lib/es6-extensions.js');
}

require('whatwg-fetch');

Object.assign = require('object-assign');

if (process.env.NODE_ENV === 'test') {
  require('raf').polyfill(global);

  // The jsdom bundled with jest 20 (jsdom 9.x) does not implement Web Storage.
  // Reducers read localStorage at import time, so provide a minimal in-memory
  // implementation for the test environment only (real browsers have it).
  if (typeof global.localStorage === 'undefined') {
    const createStorage = () => {
      let store = {};
      return {
        getItem: key => (key in store ? store[key] : null),
        setItem: (key, value) => {
          store[key] = String(value);
        },
        removeItem: key => {
          delete store[key];
        },
        clear: () => {
          store = {};
        },
        key: i => Object.keys(store)[i] || null,
        get length() {
          return Object.keys(store).length;
        }
      };
    };
    global.localStorage = createStorage();
    global.sessionStorage = createStorage();
  }
}



//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = 1204
// module chunks = 0